export class RegulatoryPraStatusHistoryModel {
  changedAt?: string;
  id?: string;
  status?: string;

  constructor(status: any) {
    this.changedAt = status.changedAt;
    this.id = status.id;
    this.status = status.status;
  }
}
